// extracted by mini-css-extract-plugin
export default {"text-yellow":"PaymentInfoTabs_text-yellow__oyV9m","select-amount":"PaymentInfoTabs_select-amount__MwJll","amount":"PaymentInfoTabs_amount__ao9yS"};